module.exports = __webpack_public_path__ + "img/pro_night.9716324e.jpg";